import React from 'react'

export default function Fqs() {
  return (
    <div className='my-5 py-3'>Fqs</div>
  )
}
